import { useQuery } from '@apollo/client/react';

import type { Kitchen, TodayProgress } from '../libs';
import { GET_TODAY_PROGRESS_QUERY } from '../libs/graphQL';

type UseTodayProgressResult = { progress: TodayProgress | undefined; loading: boolean };

type TodayProgressData = { getTodayProgress: TodayProgress };

// network-only: the count moves with every send, so a cached one would be wrong the next time Today opens.
const useTodayProgress = (kitchen: Kitchen): UseTodayProgressResult => {
  const { data, loading } = useQuery<TodayProgressData>(GET_TODAY_PROGRESS_QUERY, {
    variables: { kitchen },
    fetchPolicy: 'network-only'
  });
  return { progress: data?.getTodayProgress, loading };
};

export default useTodayProgress;
